import React from "react"

export default class CitiesListState extends React.Component 
{  
    constructor(props)
    {
        super(props);    
        this.env = this.props.env;        
        this.code = this.props.code;
        this.state = this.props.state;
        this.codes = this.props.codes;
        this.cities = this.props.cities.length > 0 ? this.props.cities : [];      
        this.cities.sort((a,b) => (a.place > b.place) ? 1 : ((b.place > a.place) ? -1 : 0));  
    }

    pickTitle = () =>
    {      
        let title = 'Top {state} Cities for {type}';
        this.codes.map(ele =>
            {
                if(ele.code === this.code)
                {
                    title = title.replace('{type}', ele.name);
                }
            })   
            
        if(this.code === 'demolition-contractors')
        {
            title = title.replace('{type}', 'Demolition Contractors');
        }
        
        title = title.replace('{state}', this.props.state.name);        
        return title;
    }

    more = () =>
    {                     
        let slug = ''
        
        this.codes.map(code =>
        {
            if(code.code === this.code)
            {                  
                slug = '/'+code.paths.name;
            }
        }) 
        
        let state = '';

        switch(this.state.slug)
        {
            case 'district-of-columbia':
                state = 'District_of_Columbia';
                break;
            
            default:
                state = this.state.slug.replace(/ /g,'_').replace(/-/g,'_');
                break;
        }
        
        const link = '/all-cities/'+state+slug;

        return(

            <a className="more" href={link}>More Places</a>

        );

    }

    render()
    {        
        return(

            <section className="section cities-list" style={{background: '#e8e8e8'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h3>{this.pickTitle()}</h3>
                        </div>
                    </div>
                    <ul className="all-cities">
                    {                       
                        this.cities.map((city, index) => 
                        {              
                            let name = city.place.split(',')[0];

                            return (
                                <li key={index}>
                                    <a href={'/'+city.url}>{name}</a>
                                </li>
                            )
                        })
                    }
                    </ul>
                    
                    {this.more()}
                </div>
            </section>

        )
    }
}